export const theme = {
  main1: "#F2EDF6",
  main2: "#E3D8EC",
  main3: "#B39ADB",
  main4: "#7848C7",
  main5: "#7100E2",
  main6: "#5A00B3",
  main7: "#490093",
  main8: "#3A0173",
  main9: "#2C0057",
  main10: "#210042",
  darker: "#2e4ac3",
  dark: "#879bf3",
  center: "#C0CCFF",
  primary: "#7100E2",
  light: "#E8E0EE",
  lighter: "#ebeffe",
  gray0: "#FFF",
  gray50: "#F9F9F9",
  gray1: "#F4F4F4",
  gray2: "#E2E2E2",
  gray3: "#CBCBCB",
  gray4: "#B4B4B4",
  gray5: "#8E8E8E",
  gray6: "#727272",
  gray7: "#484848",
  gray8: "#303030",
  gray9: "#1F1F1F",
  gary10: "#272727",
  gray11: "#A3A3A3",
  textWhite: "#FFFFFF",
  sub6: "#2C46B7",
  subRed: "#E24400",
  subOrange: "#EF8100",
  subBlue: "#3A5DF4",
};
